import { render } from "./ResultPanel.vue?vue&type=template&id=27427848"
import script from "./ResultPanel.vue?vue&type=script&lang=js"
export * from "./ResultPanel.vue?vue&type=script&lang=js"

import exportComponent from "/home/apriyadi/projects/investment-forecaster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__